<div class="home-container">
  <app-logo></app-logo>
<!--  <h1>{{'home-page.tours' | translate | titlecase}}</h1>-->
  <app-tour-list [text]="'home-page.available-tours' | translate"></app-tour-list>
  <app-category-list [text]="'home-page.categories' | translate"></app-category-list>
</div>
